import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';

/**
 * SidebarLanguageMenu Component
 * 
 * A dropdown menu component for language selection in the sidebar.
 * Allows users to switch between supported languages (English and French).
 * 
 * Features:
 * - Language switching functionality
 * - Visual indicator for current language
 * - Consistent styling with the sidebar theme
 * - Internationalization support
 * - Hover effects and smooth transitions
 */
const SidebarLanguageMenu = ({
  anchorEl,
  open,
  onClose,
  onLanguageChange,
  primaryColor = '#5757b0',
  lightPurple = '#f0f0ff'
}) => {
  const { t, i18n } = useTranslation();

  const handleLanguageChange = (language) => {
    onLanguageChange(language);
    onClose();
  };

  return (
    <Menu
      id="language-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(87, 87, 176, 0.15)',
          mt: 1
        }
      }}
    >
      <MenuItem onClick={() => handleLanguageChange('en')} sx={{ 
        minWidth: '150px',
        '&:hover': { backgroundColor: lightPurple }
      }}>
        {t('sidebar.language_english')}
        {i18n.language === 'en' && <CheckIcon fontSize="small" sx={{ ml: 1, color: primaryColor }} />}
      </MenuItem>
      <MenuItem onClick={() => handleLanguageChange('fr')} sx={{ 
        minWidth: '150px',
        '&:hover': { backgroundColor: lightPurple }
      }}>
        {t('sidebar.language_french')}
        {i18n.language === 'fr' && <CheckIcon fontSize="small" sx={{ ml: 1, color: primaryColor }} />}
      </MenuItem>
    </Menu>
  );
};

export default SidebarLanguageMenu;
